<template lang="pug">
.request-access-form
  template(v-if="finished")
    el-alert(
      show-icon
      :closable="false"
      type="success"
      title="Thank you for requesting an account!"
      description="A Pod representative will reach out to help get you started.")

  template(v-else)
    el-form.form(
      :rules="rules"
      :model="form"
      ref="form"
      v-loading="submitting"
      label-position="top"
      @submit.native.prevent)

      el-form-item.boxed(
        prop="company_name"
        label="Company name")
        el-input(v-model="form.company_name")

      el-form-item.boxed(
        prop="business_email"
        label="Business email")
        el-input(v-model="form.business_email")

      el-form-item.boxed(
        prop="website"
        label="Website")
        el-input(v-model="form.website")

      el-form-item.boxed(
        prop="contact_type"
        label="Contact type")
        el-select.pf-expanded(
          v-model="form.contact_type"
          default-first-options
          filterable)
          el-option(
            v-for="i, k in contactTypes"
            :key="k"
            :value="i.id"
            :label="i.name") {{ i.name }}

      template(v-if="is.retailer")
        el-form-item.boxed(prop="referring_brand" label="If you were referred by a brand, please let us know which one.")
          el-input(v-model="form.referring_brand" placeholder="Brand name")

        el-form-item.my-2(prop="pod_express_interest" label="Would you like to become a Pod Express customer?")
          el-radio-group(v-model="form.pod_express_interest")
            el-radio-button(label="yes") Yes
            el-radio-button(label="no") No
            el-radio-button(label="unknown") I don’t know yet

        el-form-item.mt-4(prop="agreement")
          el-checkbox.agreement(v-model="form.agreement")
            | By checking this box you agree that all purchases are for commercial use only

      el-button.pf-expanded.mt-3(
        @click="submit"
        type="primary") {{ is.retailer ? 'Next' : 'Submit' }}
</template>

<script>
import { mapGetters } from 'vuex'
import { snakeCase } from 'lodash'

export default {
  data () {
    return {
      submitting: false,
      finished: false,
      form: {}
    }
  },

  computed: {
    ...mapGetters({
      options: 'master/mondayFormOptions'
    }),

    rules () {
      const { required, email } = this.$validators

      return {
        company_name: required,
        contact_type: required,
        business_email: [required, email],
        pod_express_interest: required,
        website: required,
        agreement: {
          validator (rule, val, cb) {
            if (!val) return cb(new Error('Required'))
            cb()
          }
        }
      }
    },

    is () {
      const contactType = this.contactTypes
        .find(i => i.id === this.form.contact_type)
      const roleName = contactType?.name.toLowerCase() || ''
      return {
        vendor: roleName.includes('vendor'),
        broker: roleName.includes('broker'),
        retailer: roleName.includes('retailer')
      }
    },

    contactTypes () {
      const options = this.options?.inbound_registration_form?.contact_types || []
      return options.map(i => ({ ...i, id: snakeCase(i.name) }))
    }
  },

  watch: {
    'form.contact_type' () {
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    }
  },

  methods: {

    submit () {
      return this.$refs.form?.validate(ok => {
        if (!ok) return
        this.submitting = true
        return this.$api.common
          .submitRequestAccessForm(this.form)
          .then(res => {
            this.finished = true
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.request-access-form {
  ::v-deep {
    .el-checkbox {
      display: flex;
      white-space: initial;
      > * {
        min-width: 0;
      }
      &__input {
        margin-top: .2em;
      }
    }
  }
  .agreement {
    ::v-deep {
      .el-checkbox {
        &__label:before {
          content: '*';
          color: $--color-danger;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
